// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"3ffd06de","55":"1641db3e","154":"27052497","377":"fa73edf0","448":"b7b4d612","488":"1446b851","492":"d6e9bf35","751":"01f175b4","761":"f3c0dca2","876":"b99f6b86","979":"7f8a4bfe"}[chunkId] + ".chunk.js";
};